export const DESKTOP = "DESKTOP";
export const TABLET = "TABLET";
export const MOBILE = "MOBILE";

export const isMobile = (windowSize: number) => windowSize < 813;
export const isTablet = (windowSize: number) =>
  windowSize >= 813 && windowSize <= 1024;
export const isDesktop = (windowSize: number) => windowSize > 1024;

export const determineViewportCategory = (windowSize: number) => {
  if (isMobile(windowSize)) {
    return MOBILE;
  }
  if (isTablet(windowSize)) {
    return TABLET;
  }
  return DESKTOP;
};
